import { Stack } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";

import {
  HubHookFormDatePicker,
  HubHookFormInput,
  HubPrioritySelect,
  WorkOrderRoutingSelect,
} from "../../components";
import { onUpdateDateHelper } from "../../tables/OrderLineItemsTable/helper";

const QuickWorkOrderForm = ({ percent, workOrder, part = {} }) => {
  const { setValue } = useFormContext();
  const disabled = percent > 0;
  const partsPerTree = part?.partsPerTree;
  const leadTime = part?.leadTime;

  const onUpdateQuantity = (_, qty) => {
    if (disabled) return;
    const value = Number(qty) || partsPerTree;
    const trees = Math.ceil(value / partsPerTree);
    const patReq = trees * partsPerTree;

    setValue("quantity", patReq);
    setValue("trees", trees);
  };

  const onUpdateTrees = (_, trees) => {
    if (disabled) return;
    const value = Number(trees) || 1;
    const patReq = value * partsPerTree;

    setValue("quantity", patReq);
    setValue("trees", value);
  };

  const onUpdateDate = (value, isStart = false) => {
    if (disabled) return;
    const { startDate, dueDate } = onUpdateDateHelper(value, isStart, leadTime);

    setValue("startDate", startDate);
    setValue("dueDate", dueDate);
  };

  return (
    <Stack gap="15px">
      <Stack direction="row" gap="5px" alignItems="center">
        <WorkOrderRoutingSelect
          name="routeId"
          workOrder={workOrder}
          label="Current Route"
        />
        <HubPrioritySelect name="priority" label="Priority" />
      </Stack>

      <Stack direction="row" gap="5px" alignItems="center">
        <HubHookFormInput
          name="trees"
          label="Trees"
          onBlur={onUpdateTrees}
          disabled={disabled}
          isNumber
          required
        />
        <HubHookFormInput
          name="quantity"
          label="Quantity"
          onBlur={onUpdateQuantity}
          disabled={disabled}
          isNumber
          required
        />
      </Stack>

      <Stack direction="row" gap="5px" alignItems="center">
        <HubHookFormDatePicker
          name="startDate"
          label="Start Date"
          disabled={disabled}
          onChange={(value) => onUpdateDate(value, true)}
          required
        />
        <HubHookFormDatePicker
          name="dueDate"
          label="Due Date"
          disabled={disabled}
          onChange={(value) => onUpdateDate(value)}
          required
        />
      </Stack>
    </Stack>
  );
};

export default QuickWorkOrderForm;
